"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneAuthForm = PhoneAuthForm;
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var _PhoneField = require("../PhoneField");
var _FieldGroupLayout = require("../FieldGroupLayout");
var _keyCodes = require("../../types/keyCodes");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function PhoneAuthForm(_ref) {
  let {
    phoneRef,
    isSubmitting,
    autoFocusDisabled,
    phone,
    onPhoneChange,
    phoneError,
    isPhoneInvalid,
    hideOtherAuthMethodsButton,
    handleSubmit,
    onSwitchAuthType,
    isBlocked
  } = _ref;
  const handlePreventSubmit = React.useCallback(e => {
    e.preventDefault();
  }, []);
  const handleSubmitOnEnter = React.useCallback(e => {
    if (e.keyCode === _keyCodes.EKeyCode.Enter) {
      handleSubmit();
    }
  }, [handleSubmit]);
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: handlePreventSubmit
  }, /*#__PURE__*/React.createElement(_FieldGroupLayout.FormFieldGroupLayout, {
    content: /*#__PURE__*/React.createElement(_PhoneField.PhoneField, {
      autoComplete: "tel",
      autoFocus: !autoFocusDisabled,
      name: "tel",
      inputRef: phoneRef,
      value: phone,
      onKeyDown: handleSubmitOnEnter,
      onValueChange: onPhoneChange,
      disabled: isSubmitting || isBlocked,
      invalid: isPhoneInvalid,
      errorMessage: phoneError,
      placeholder: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D"
    }),
    buttons: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_uiKit.Button, {
      "data-name": "ContinueAuthBtn",
      type: "submit",
      theme: "fill_primary",
      loading: isSubmitting,
      disabled: isSubmitting || isBlocked,
      onClick: handleSubmit,
      fullWidth: true
    }, "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043A\u043E\u0434"), !hideOtherAuthMethodsButton && /*#__PURE__*/React.createElement(_uiKit.Button, {
      "data-name": "SwitchToEmailAuthBtn",
      theme: "fill_secondary",
      onClick: onSwitchAuthType,
      fullWidth: true
    }, "\u0414\u0440\u0443\u0433\u043E\u0439 \u0441\u043F\u043E\u0441\u043E\u0431"))
  }));
}